import { FC, useEffect } from 'react';

import { Box } from '@material-ui/core';
import { isBrowser } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import ErrorBoxComponent from 'src/components/ErrorBox';
import { AuthenticationPlatform } from 'src/contexts/AuthContext';
import { useIframeUtils } from 'src/contexts/IframeUtilsContext';
import LoginBoxSe from 'src/customerPages/components/auth/LoginBoxSe';
import { useCustomerLogin } from 'src/customerPages/context/login/CustomerLoginContext';
import PageHeightOffsets from 'src/customerPages/utils/iframe/pageHeightOffsets';
import useAuth from 'src/hooks/useAuth';
import useQuery from 'src/hooks/useQuery';
import { externalAuthPlatforms } from 'src/utils/auth/authPlatforms';

import LoginHeader from '../../layout/auth/LoginHeader';

interface CustomerLoginPageSeProps {
  autoLogin?: boolean;
  redirectTo?: string;
}

const CustomerLoginPageSe: FC<CustomerLoginPageSeProps> = (props) => {
  const { autoLogin = false, redirectTo = '/' } = props;
  const { t } = useTranslation();
  const { platform, completeState, changePlatform, setImpersonationToken } = useAuth();
  const { heightOffset } = useIframeUtils();
  const navigate = useNavigate();
  const { loginSe } = useCustomerLogin();

  const [queryToken] = useQuery('access_token', '');

  useEffect(() => {
    if (queryToken) setImpersonationToken(queryToken);
  }, [queryToken, setImpersonationToken]);

  useEffect(() => {
    if (!externalAuthPlatforms.includes(platform)) changePlatform(AuthenticationPlatform.BankIdSe);
  }, [platform]);

  useEffect(() => {
    heightOffset.current = PageHeightOffsets.login;
  }, []);

  useEffect(() => {
    // eslint-disable-next-line curly
    if (autoLogin) {
      if (isBrowser) navigate({ pathname: '/qr-login', search: `?redirectTo=${redirectTo}` });

      else loginSe(true);
    }
  }, [autoLogin]);

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%', height: '100%', p: 0 }}
    >
      <LoginHeader />
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', p: 0 }}
      >
        <Box sx={{ width: '500px', maxWidth: '90%' }}>
          <LoginBoxSe redirectTo={redirectTo} />
          {completeState === 'timeout' && (
            <ErrorBoxComponent
              severity="warning"
              errorMessage={t('You were logged out. Please log in again.')}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerLoginPageSe;
